/**
 * Helpers de parse JSON tolerantes a dados corrompidos/truncados.
 *
 * Motivação: navegadores (principalmente Safari/iOS) podem devolver valores de
 * localStorage truncados ou respostas de rede cortadas quando a conexão cai,
 * gerando `SyntaxError: JSON Parse error: Unterminated string` e quebrando a
 * tela quando o parse acontece em inicializador de `useState`.
 */

/** Faz JSON.parse sem lançar. Retorna `fallback` quando o conteúdo é inválido. */
export function safeJsonParse<T>(raw: string | null | undefined, fallback: T): T {
  if (raw == null || raw === '') return fallback;
  try {
    const parsed = JSON.parse(raw);
    return (parsed ?? fallback) as T;
  } catch {
    return fallback;
  }
}

/**
 * Lê e faz parse de uma chave do localStorage. Se o valor estiver corrompido,
 * remove a chave (para não repetir o erro) e devolve o fallback.
 */
export function safeStorageJson<T>(key: string, fallback: T): T {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(key);
  } catch {
    return fallback;
  }
  if (raw == null || raw === '') return fallback;
  try {
    const parsed = JSON.parse(raw);
    return (parsed ?? fallback) as T;
  } catch {
    console.warn(`[safeJson] Valor corrompido em localStorage["${key}"], limpando.`);
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
    return fallback;
  }
}
